import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import preload from 'redux-preload';
import { connect } from 'react-redux';
import { Grid, Col, Row, Table } from 'react-bootstrap';

import DownloadButton from './download_button';
import { fetchDownloads } from './actions';

@connect(({ downloads: files }) => ({ files }))
@preload(fetchDownloads)
export default class DownloadPage extends React.Component {
  static propTypes = {
    files: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        file_url: PropTypes.string.isRequired
      })
    ).isRequired
  }

  render() {
    const { files } = this.props;

    return (
      <Grid>
        <Helmet>
          <title>Ke stažení - Stužák</title>
        </Helmet>
        <Row>
          <Col md={8} mdOffset={2}>
            <h2>Ke stažení</h2>
            <Table striped responsive hover>
              <thead>
                <tr>
                  <th>Soubor</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                { files.map(file =>
                  <tr key={`file-${file.name}`}>
                    <td>{file.name}</td>
                    <td><DownloadButton fileUrl={file.file_url} /></td>
                  </tr>
                )}
              </tbody>

            </Table>
          </Col>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/downloads/index.jsx